import { yes } from '@silverhand/essentials';

export const isCloud = yes(process.env.IS_CLOUD);
